import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Card } from "react-bootstrap";
import { NumericFormat } from 'react-number-format';
import { Button, SvgIcon } from '@mui/material';
import CheckCircleIcon from '../../../../icons/check-circle.svg?react';

import './QuoteCard.scss';

export default function QuoteCard(props) {

    return (
        <Card onClick={() => {
            if (!props.disabled) props.flipActive();
        }
        }
            className={`aflac-quote-card p-3 shadow-sm ${props.active ? "aflac-quote-card-active" : ''} ${props.disabled ? "greyOut" : "notDisabled"}`}
        >
            <Col>
                <Row>
                    <Col className="p-0">
                        <img src={props.iconUrl} className="mb-2" alt="" />
                    </Col>
                    <Col xs="auto" className="p-0" >
                        <SvgIcon component={CheckCircleIcon} className={props.active ? "primary-color" : "greyOut"} />
                    </Col>
                </Row>
                <Row>
                    <h3 className={`${props.disabled ? "greyOut" : ''} multiline`}>{props.title}</h3>
                </Row>
                <Row>
                    {!props.loading && props.monthlyRate ?
                        <span className='px-0'>
                            <NumericFormat
                                className="quote-amount-dollars"
                                value={props.monthlyRate}
                                displayType={'text'}
                                thousandSeparator={true}
                                decimalScale={2}
                                fixedDecimalScale={true}
                            />
                            <span className="quote-amount-mo"> /mo</span>
                        </span>
                        :
                        <span className="dots">...</span>}
                </Row>
                <Row>
                    <Button className='px-0' variant="text" color="primary" onClick={props.productDetailsOnClick} disabled={props.disabled}>PRODUCT DETAILS</Button>
                </Row>
                <Row><p>{props.disclaimers}</p></Row>
            </Col>
        </Card>
    )
}

QuoteCard.propTypes = {
    title: PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.object.isRequired,
    ]),
    iconUrl: PropTypes.string.isRequired,
    monthlyRate: PropTypes.number,
    productDetailsOnClick: PropTypes.func.isRequired,
    active: PropTypes.bool,
    flipActive: PropTypes.func.isRequired,
    disclaimers: PropTypes.string,
    disabled: PropTypes.bool,
    loading: PropTypes.bool.isRequired
}
